import { useWatch } from 'react-hook-form';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CalendarIcon } from '@zep-us/zus-icons';
import { formatUsagePeriodRange } from '../utils/calculateUsagePeriod';
import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';

/** 예정 사용 일자 — 시작일 + 기간으로 계산된 사용 범위 (Figma "Date section"). */
export function UsagePeriodPreview() {
  const startDate = useWatch<QuizQuoteFormValues, 'start_date'>({
    name: 'start_date'
  });
  const term = useWatch<QuizQuoteFormValues, 'term'>({
    name: 'term'
  });
  const range = formatUsagePeriodRange(startDate ?? '', term ?? 0);
  if (!range) {
    return null;
  }
  return <div className="flex w-full items-center justify-between" data-sentry-component="UsagePeriodPreview" data-sentry-source-file="UsagePeriodPreview.tsx">
      <div className="flex items-center gap-2xs">
        <CalendarIcon size="xs" fill={ICON_COLOR.default} data-sentry-element="CalendarIcon" data-sentry-source-file="UsagePeriodPreview.tsx" />
        <span className="text-body-md-semibold text-neutral">
          예정 사용 일자
        </span>
      </div>
      <span className="text-body-md-semibold text-strong">{range}</span>
    </div>;
}